module.exports = __webpack_public_path__ + "img/loading.bf0b1aa0.svg";